import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useGetPurchaseOrder } from '@/services/apis/queries/purchase-order/use-get-purchase-order';

type PurchaseOrderMainDeliveryProps = {
  purchaseOrderId: string;
};

export function PurchaseOrderMainDelivery({
  purchaseOrderId,
}: PurchaseOrderMainDeliveryProps) {
  const { t } = useTranslation('purchaseOrder');
  const { data: purchaseOrder } = useGetPurchaseOrder(purchaseOrderId);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('cardDelivery')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className='flex items-center justify-between gap-2'>
          <span className='text-muted-foreground text-sm'>
            {t('deliveryWarehouseLabel')}
          </span>
          <span className='font-medium text-sm'>
            {purchaseOrder.warehouse?.name ?? '--'}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
